<template>
  <div>
    <template v-if="whatsapp">
      <NotificationTag ref="notification" :tag="tag" />
      <i class="fa fa-whatsapp tag-icon" style="cursor: pointer;" :class="{ green: notification }" aria-hidden="true"
        @click="$refs.notification.open()"></i>
    </template>
    <el-link @click="open(tag)">{{ tag }}</el-link>
    <i class="el-icon-document-copy tag-icon" style="cursor: pointer;" v-clipboard:copy="tag" @click="copy()"></i>
    <!-- v-if: o TagLink é renderizado por linha (a lista vai a 1000 registros),
         então o modal só existe na linha que foi clicada. -->
    <PrepostEdit
      v-if="opened"
      :tag="tag"
      :dialog="opened"
      :state="editable ? '' : 'VIEW'"
      tab="tracking"
      v-on:close="opened = false"
    />
  </div>
</template>

<script>
import { i18n } from "@/plugin/i18n";
import NotificationTag from "./NotificationTag.vue";
import PrepostEdit from "@/xpost/views/services/pre.post/PrePostEdit.vue";
export default {
  name: "TagLink",
  props: {
    tag: String,
    // Não é mais usado (não há navegação), mantido para não quebrar as 8 telas
    // que já o passam. A rota objects.sro.tag segue para link direto.
    back: String,
    notification: { default: undefined },
    // A tela decide: listagem de pré-postagem edita, listagem de objeto já
    // postado é só leitura. Precisa de `type: Boolean` para `<TagLink editable />`
    // virar `true` — em props declaradas como array viraria string vazia.
    editable: { type: Boolean, default: false },
    // A listagem unificada mostra o WhatsApp na coluna de ações; aqui some
    whatsapp: { type: Boolean, default: true },
  },
  data() {
    return {
      opened: false,
    };
  },
  methods: {
    copy() {
      this.$message({
        type: "success",
        message: "Objeto copiado com sucesso",
      });
    },
    open() {
      // Abre na hora: a aba Rastreio não depende da prepostagem, e a aba Etiqueta
      // é lazy — ela resolve a etiqueta sozinha quando (e se) for aberta.
      this.opened = true;
    },
  },
  components: { NotificationTag, PrepostEdit }
}
</script>
<style> .tag-icon {
   margin-left: 5px;
   margin-right: 5px;
 }

 .green {}
</style>